import React from 'react';
import Helmet from 'react-helmet';
import injectSheet from 'react-jss';

import './index.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const headerHeight = '4.2rem';

class Contents extends React.Component {
    componentDidUpdate() {
        if (this.props.onUpdate) {
            this.props.onUpdate();
        }
    }
    
    render() {
        return (
            <article className={this.props.classes.content}>
                {this.props.children()}
            </article>
        );
    }
}

class Layout extends React.Component {
    constructor() {
        super();

        this.state = {
            menuExpanded: false
        };

        this.menuWillChange = false;
    }
    
    render() {
        const menu = [
            { label: 'Home', to: '/' },
            { label: 'Use case', to: '/usecase' },
            { label: 'FAQ', to: '/faq' },
            { label: 'Forum', to: 'https://www.reddit.com/r/onairvr/' },
            { label: 'Downloads', to: '/downloads'}
        ];

        const contentsUpdated = () => {
            if (this.menuWillChange == false && this.state.menuExpanded) {
                this.setState({
                    menuExpanded: false
                });
            }
            else {
                this.menuWillChange = false;
            }
        };

        const toggleMenu = () => {
            this.setState({
                menuExpanded: !this.state.menuExpanded
            });
            this.menuWillChange = true;
        };
        
        return (
            <div>
                <Helmet
                    title={this.props.data.site.siteMetadata.title}
                    meta={[
                        { name: 'description', content: 'the official site of onAirVR' },
                        { name: 'keywords', content: 'onairvr, vr, wireless' },
                    ]}
                    />
                <Header
                    logoWidth='11.7rem'
                    hamburgerWidth='2rem'
                    menuTemplate={menu}
                    sizesLogo={this.props.data.imageLogo.childImageSharp.sizes}
                    sizesHamburger={this.props.data.imageHamburger.childImageSharp.sizes}
                    menuExpanded={this.state.menuExpanded}
                    onToggleMenu={toggleMenu}
                    />
                <Contents
                    classes={this.props.classes}
                    children={this.props.children}
                    onUpdate={contentsUpdated}
                    />
                <Footer />
            </div>
        );
    }
}

const styles = {
    content: {
        marginTop: headerHeight,
        backgroundColor: '#F7F7F7',
        '@media only screen and (max-width: 1000px)': {
            marginTop: 0
        }
    }
};

export default injectSheet(styles)(Layout);

export const query = graphql`
    query IndexLayoutQuery {
        ...IndexLayoutFragment
    }

    fragment IndexLayoutFragment on RootQueryType {
        site {
            siteMetadata {
                title
            }
        }
        imageLogo: file(relativePath: { eq: "onairvr_logo.png" }) {
            childImageSharp {
                sizes(maxWidth: 177) {
                    ...GatsbyImageSharpSizes
                }
            }
        }
        imageHamburger: file(relativePath: { eq: "icon_hamburger.png" }) {
            childImageSharp {
                sizes(maxWidth: 128) {
                    ...GatsbyImageSharpSizes
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js